<script>
  import Header from "lib/components/Header.svelte";
  import { fetchWithSession } from "../../../../lib/util/fetchWithSession";
  import { recordingStore } from "@stores/recordingStore.js";
  import PercentageBar from "../../../../lib/components/PercentageBar.svelte";
  import AnonElement from "../components/AnonElement.svelte";
  import { getContext, onMount, tick } from "svelte";
  import Modal from "../../../../lib/components/Modal.svelte";
  import { Loading } from "carbon-components-svelte";
  import { fly } from "svelte/transition";
  import { ROUTES } from "@utils/routes.js";
  import PaxbotChat from "lib/components/paxbot/PaxbotChat.svelte";
  import { SectionWrapper, Button } from "paxray-components-svelte";
  import {
    BOT_WHITE_ICON,
    CHECK_ICON,
    CHEVRON_DOWN_ICON,
    CHEVRON_UP_ICON,
    CLOSE_ICON,
    DONE_ALL_DARK_ICON,
    DONE_ALL_ICON,
    JOIN_INNER_ALT_ICON,
  } from "@utils/icons.js";
  import {
    splitString,
    getSpaceBoundaryIndices,
  } from "./anonymizationTextSplit.js";
  import AnonymizationReviewFilters from "./AnonymizationReviewFilters.svelte";
  import AnonymizationReviewPagination from "./AnonymizationReviewPagination.svelte";
  import AnonymizationShortcutPanel from "./AnonymizationShortcutPanel.svelte";
  import AnonymizationRuleModal from "./AnonymizationRuleModal.svelte";
  import ProjectStepActions from "../components/ProjectStepActions.svelte";
  import { PROJECT_STAGES } from "@utils/stagesAndSteps.js";

  export let selectedReviewType = 0;

  let urlParams = new URLSearchParams(window.location.search);
  let idproject = urlParams.get("idproject");
  let projectStageId;

  let checkedStrings = 0;
  let appsFinished = 0;
  let selectedOption = "all";
  let selectedApplicationIds = [];
  let filteredTotalCount = 0;
  let openModal = false;
  let windowtitleRuleModalOpen = false;
  let safeTitleModalOpen = false;
  let pendingSafeTitle = null;
  let windowtitleRulePreview = null;
  let windowtitleRuleLoading = false;
  let windowtitleRuleLoadingTimer;
  let searchQuery = "";
  let isLoading = true;

  let pendingChangeValue = "";
  let pendingChangeType = "";
  let saveSuccessful = false;
  let rowToChange = null;
  let pendingOriginalType = "";
  let pendingOriginalAnonymized = "";
  let pendingOriginalCheck = false;
  let pendingSubstring = null;
  let pendingSubstringIndex = -1;
  let pendingGroup = null;
  let pendingPreviewRows = [];
  let selectedElements = [];
  let selectedElementKeys = [];
  let selectedElementValues = [];
  let shiftPressed = false;
  let sortByOption = "charlength";
  let selectedProcess = "";
  let selectedSubprocess = "";
  let selectedTeam = "";
  let selectedTask = "";
  let selectedSubtask = "";
  let selectedAssignedOption = "";
  let selectedWindowtitleScope = 0;
  let showApplicationName = true;
  const role = getContext("role");
  const completionStep = PROJECT_STAGES.TASK_REGISTRATION.steps.CHECK_ANON;
  const completionStage = PROJECT_STAGES.TASK_REGISTRATION.id;

  $: selectedElementKeys = selectedElements.map((selected) => selected.key);
  $: selectedElementValues = selectedElements.map((selected) => ({
    type: selected.substring.type,
    removeAnonType: selected.value,
  }));
  let filtersInitialized = false;
  let selectOptions = [
    { value: "checked", text: "Checked" },
    { value: "unchecked", text: "Not Checked" },
  ];

  let sortByOptions = [
    { value: "anonTitle", text: "Title" },
    { value: "charlength", text: "Length" },
  ];

  let amountItemsOptions = [
    { value: "5", text: "5" },
    { value: "10", text: "10" },
    { value: "15", text: "15" },
    { value: "20", text: "20" },
    { value: "25", text: "25" },
  ];

  let mainAnon = [
    { key: "number", value: "NUMBER", original: "<<<NUMBER>>>" },
    { key: "name", value: "NAME", original: "<<<NAME>>>" },
    { key: "company", value: "COMPANY", original: "<<<COMPANY>>>" },
    { key: "id", value: "ID", original: "<<<ID>>>" },
  ];

  let time = [
    { key: "date", value: "DATE", original: "<<<DATE>>>" },
    { key: "year", value: "YEAR", original: "<<<YEAR>>>" },
    { key: "month", value: "MONTH", original: "<<<MONTH>>>" },
    { key: "week", value: "WEEK", original: "<<<WEEK>>>" },
    { key: "day", value: "DAY", original: "<<<DAY>>>" },
    { key: "time", value: "TIME", original: "<<<TIME>>>" },
  ];

  let context = [
    { key: "location", value: "LOCATION", original: "<<<LOCATION>>>" },
    { key: "adress", value: "ADRESS", original: "<<<ADRESS>>>" },
    { key: "tel", value: "URL", original: "<<<URL>>>" },
    { key: "path", value: "PATH", original: "<<<PATH>>>" },
  ];

  let misc = [
    { key: "text", value: "TEXT", original: "<<<TEXT>>>" },
    { key: "product", value: "PRODUCT", original: "<<<PRODUCT>>>" },
    { key: "amount", value: "AMOUNT", original: "<<<AMOUNT>>>" },
    { key: "email", value: "EMAIL", original: "<<<EMAIL>>>" },
    { key: "version", value: "VERSION", original: "<<<VERSION>>>" },
  ];

  let anontypeOptionsMap = {
    mainAnon: {
      title: "Main Anon",
      options: mainAnon,
    },
    time: {
      title: "Time",
      options: time,
    },
    context: {
      title: "Context",
      options: context,
    },
    misc: {
      title: "Misc",
      options: misc,
    },
  };

  let selectedAmountItems = "10";
  let startIndex = 0;
  let listOfRows = [];
  let assignedRows = [];
  let allRows = [];
  let loadedRowsByScope = { assigned: null, global: null };
  let requestedWindowtitleScope = null;
  let appNameMappings = null;
  let loadGeneration = 0;
  let filteredRows = [];
  let groupedRows = [];
  let expandedGroups = {};
  let pageSize = 0;
  let hasPreviousPage = false;
  let hasNextPage = false;
  let totalPages = 0;
  let appOptions = [];
  let totalApps = 0;
  let totalStrings = 0;
  let availableSubtasks = [];
  let taskOrderedSubtasks = [];
  let hasNextTask = false;
  let keyboardRowKey = "";
  let keyboardColumnIndex = 0;
  let keyboardNavigationActive = false;
  let keyboardSelectionAnchor = null;
  let paxbotOpen = false;

  const paxbotStarterQuestions = [
    "Which visible entries should I review first?",
    "Which anonymization types look inconsistent?",
    "What remains unchecked?",
    "Explain the keyboard shortcuts.",
  ];

  $: ({
    processes,
    listOfSubprocesses,
    listOfTasks,
    listOfSubtasks,
    listOfRecordings,
    listOfTeams,
    _initialized: filtersInitialized,
  } = $recordingStore);

  $: selectedApplicationLabel =
    selectedApplicationIds.length === 0
      ? "All"
      : selectedApplicationIds.length === 1
        ? selectedApplicationIds[0]
        : `${selectedApplicationIds.length} selected`;

  $: pageSize = parseInt(selectedAmountItems, 10) || 0;
  $: taskOrderedSubtasks = listOfTasks
    .slice()
    .sort((a, b) => a.name.localeCompare(b.name))
    .flatMap((task) =>
      availableSubtasks
        .filter((subtask) => String(subtask.task_id) === String(task.id))
        .sort((a, b) => a.name.localeCompare(b.name)),
    );
  $: activeSubtaskIndex = taskOrderedSubtasks.findIndex(
    (subtask) => String(subtask.id) === String(selectedSubtask),
  );
  $: hasPreviousPage = startIndex > 0;
  $: hasNextPage = totalPages > 0 && startIndex + 1 < totalPages;
  $: hasNextTask =
    Boolean(selectedSubtask) &&
    !hasNextPage &&
    activeSubtaskIndex >= 0 &&
    taskOrderedSubtasks.length > 1;
  $: if (totalPages > 0 && startIndex >= totalPages) startIndex = 0;

  $: hasActiveFilters = Boolean(
    selectedProcess ||
      selectedSubprocess ||
      selectedTask ||
      selectedSubtask ||
      selectedTeam ||
      selectedAssignedOption ||
      selectedOption,
  );

  $: if (
    projectStageId &&
    requestedWindowtitleScope !== selectedWindowtitleScope
  ) {
    requestedWindowtitleScope = selectedWindowtitleScope;
    getAnonymizationAsisstant(
      selectedWindowtitleScope === 0 ? "assigned" : "global",
    );
  }

  $: {
    const scope = selectedWindowtitleScope === 0 ? "assigned" : "global";
    const loadedRows = loadedRowsByScope[scope];
    if (loadedRows) {
      listOfRows =
        selectedWindowtitleScope === 2
          ? loadedRows.filter((row) => !isAssignedRow(row))
          : loadedRows;
      appOptions = getApplications(listOfRows);
      const availableApplicationIds = new Set(
        appOptions.map((option) => option.id),
      );
      const validSelectedApplicationIds = selectedApplicationIds.filter((id) =>
        availableApplicationIds.has(id),
      );
      if (
        validSelectedApplicationIds.length !== selectedApplicationIds.length
      ) {
        selectedApplicationIds = validSelectedApplicationIds;
      }
      totalApps = appOptions.length;
      totalStrings = listOfRows.length;
      updatePercentageBars();
    }
  }

  $: {
    let tempRows = listOfRows;

    if (searchQuery) {
      tempRows = tempRows.filter(
        (row) =>
          row.windowtitleString &&
          row.windowtitleString
            .toLowerCase()
            .includes(searchQuery.toLowerCase()),
      );
    }

    if (selectedOption === "checked") {
      tempRows = tempRows.filter((row) => row.check);
    } else if (selectedOption === "unchecked") {
      tempRows = tempRows.filter((row) => !row.check);
    }

    if (selectedApplicationIds.length > 0) {
      const selectedApplications = new Set(selectedApplicationIds);
      tempRows = tempRows.filter((row) =>
        selectedApplications.has(row.clearname || row.applicationname),
      );
    }

    if (filtersInitialized) {
      tempRows = tempRows.filter((row) => rowMatchesLFilters(row, true));
    }

    if (sortByOption === "length") {
      tempRows = [...tempRows].sort(
        (a, b) => b.substringsRaw.length - a.substringsRaw.length,
      );
    } else if (sortByOption === "charlength") {
      tempRows = [...tempRows].sort(
        (a, b) => b.fullstringLength - a.fullstringLength,
      );
    } else if (sortByOption === "anonTitle") {
      tempRows = [...tempRows].sort((a, b) =>
        a.anonymizedString.localeCompare(b.anonymizedString),
      );
    } else if (sortByOption === "noAnonTitle") {
      tempRows = [...tempRows].sort((a, b) =>
        a.windowtitleString.localeCompare(b.windowtitleString),
      );
    }

    const availableSubtaskIds = new Set(
      tempRows.flatMap((row) =>
        (row.subtasks || []).map((subtask) => String(subtask.id)),
      ),
    );
    const nextAvailableSubtasks = listOfSubtasks
      .filter((subtask) => availableSubtaskIds.has(String(subtask.id)))
      .sort((a, b) => a.name.localeCompare(b.name));
    availableSubtasks = nextAvailableSubtasks;

    if (
      selectedSubtask &&
      !nextAvailableSubtasks.some(
        (subtask) => String(subtask.id) === String(selectedSubtask),
      )
    ) {
      // Reset only a no-longer available explicit L4 selection. Keep the
      // visible "All" state unfiltered instead of selecting an L4 implicitly.
      selectedSubtask = "";
      startIndex = 0;
    }

    tempRows = selectedSubtask
      ? tempRows.filter((row) =>
          row.subtasks?.some(
            (subtask) => String(subtask.id) === String(selectedSubtask),
          ),
        )
      : tempRows;

    filteredTotalCount = tempRows.length;
    const grouped = buildGroupedRows(tempRows);
    const pages = paginateGroups(grouped, pageSize);

    totalPages = pages.length;
    groupedRows = pages[startIndex] || pages[0] || [];
    filteredRows = getRowsFromGroups(groupedRows);
  }

  function buildGroupedRows(rows) {
    const subtaskMap = {};
    for (const row of rows) {
      const matchingSubtasks = selectedSubtask
        ? row.subtasks.filter(
            (subtask) => String(subtask.id) === String(selectedSubtask),
          )
        : row.subtasks;
      if (!matchingSubtasks.length) continue;
      const subtasks = matchingSubtasks;
      for (const subtask of subtasks) {
        const subtaskKey = String(subtask.id);
        if (!subtaskMap[subtaskKey]) {
          subtaskMap[subtaskKey] = {
            id: subtaskKey,
            name: subtask.name || "Unassigned",
            groups: [],
            exactGroups: new Map(),
            exactWindowTitleGroups: new Map(),
            similarityIndex: new Map(),
          };
        }

        addRowToAnonymizationGroup(subtaskMap[subtaskKey], row);
      }
    }
    return Object.values(subtaskMap).map(({ id, name, groups }) => ({
      id,
      name,
      groups: groups.map((group) => group.rows),
    }));
  }

  // @adrian: This is the central matching block. We deliberately do not
  // compare every row with every other row because that would become O(n²).
  // First, an exact structural key catches identical patterns in O(n). For
  // longer titles, only rows with the same token count and the same
  // anonymization-type positions become candidates. A small positional anchor
  // index reduces the candidates further before the similarity score runs.
  // This keeps matching fast while still grouping variants such as "20th",
  // "21st" and "22nd" in an otherwise identical title.
  function addRowToAnonymizationGroup(subtaskGroup, row) {
    const windowTitleKey = normalizeWindowTitleKey(row.windowtitleString);
    let group = subtaskGroup.exactWindowTitleGroups.get(windowTitleKey);
    if (group) {
      const matchingRows = group.rows.filter(
        (candidate) =>
          normalizeWindowTitleKey(candidate.windowtitleString) ===
          windowTitleKey,
      );
      const otherRows = group.rows.filter(
        (candidate) =>
          normalizeWindowTitleKey(candidate.windowtitleString) !==
          windowTitleKey,
      );
      if (otherRows.length) {
        group.rows = otherRows;
        group.representative = otherRows[0];
        group = { representative: matchingRows[0], rows: matchingRows };
        subtaskGroup.groups.push(group);
        subtaskGroup.exactWindowTitleGroups.set(windowTitleKey, group);
      }
    }
    const matchesExistingWindowTitle = Boolean(group);
    const exactKey = getAnonymizationGroupKey(row);
    if (!group) group = subtaskGroup.exactGroups.get(exactKey);

    if (!group && row.substringsRaw.length >= 9) {
      const shapeKey = getAnonymizationShapeKey(row);
      const candidateGroups = new Set();

      for (const anchorKey of getSimilarityAnchorKeys(row)) {
        const indexedGroups = subtaskGroup.similarityIndex.get(
          `${getAnonymizationAppKey(row)}|${shapeKey}|${anchorKey}`,
        );
        indexedGroups?.forEach((candidate) => candidateGroups.add(candidate));
      }

      group = [...candidateGroups].find(
        (candidate) =>
          getSharedAnchorCount(candidate.representative, row) >= 3 &&
          isSimilarAnonymizationRow(candidate.representative, row),
      );
    }

    if (!group) {
      group = {
        representative: row,
        rows: [],
      };
      subtaskGroup.groups.push(group);
    }

    if (!group.rows.includes(row)) group.rows.push(row);
    if (matchesExistingWindowTitle) group.rows.exactWindowTitleGroup = true;
    subtaskGroup.exactWindowTitleGroups.set(windowTitleKey, group);
    subtaskGroup.exactGroups.set(exactKey, group);

    const shapeKey = getAnonymizationShapeKey(row);
    for (const anchorKey of getSimilarityAnchorKeys(row)) {
      const indexKey = `${getAnonymizationAppKey(row)}|${shapeKey}|${anchorKey}`;
      if (!subtaskGroup.similarityIndex.has(indexKey)) {
        subtaskGroup.similarityIndex.set(indexKey, new Set());
      }
      subtaskGroup.similarityIndex.get(indexKey).add(group);
    }
  }

  // @adrian: The shape key is intentionally stricter than the similarity
  // score. It prevents comparing titles with different token counts or with
  // NAME/DATE/etc. in different positions. Static token values are excluded
  // here because those are exactly what the similarity check may vary.
  function getAnonymizationShapeKey(row) {
    return (row.substringsRaw || [])
      .map((substring) =>
        isAnonymizationType(substring.type) ? `anon:${substring.type}` : "text",
      )
      .join("|");
  }

  // @adrian: Anchors are stable, meaningful static tokens used to find
  // plausible candidates. Punctuation and one-character tokens are ignored
  // so common separators such as "-" do not create large candidate buckets.
  function getSimilarityAnchorKeys(row) {
    return (row.substringsRaw || [])
      .map((substring, index) => ({
        index,
        value: normalizeGroupToken(substring.value),
        isAnonymized: isAnonymizationType(substring.type),
      }))
      .filter(
        ({ value, isAnonymized }) =>
          !isAnonymized && value.length >= 3 && /[a-z0-9]/i.test(value),
      )
      .map(({ index, value }) => `${index}:${value}`);
  }

  // @adrian: Requiring several shared positional anchors prevents generic
  // titles with only one common word from being grouped accidentally.
  function getSharedAnchorCount(firstRow, secondRow) {
    const secondAnchors = new Set(getSimilarityAnchorKeys(secondRow));
    return getSimilarityAnchorKeys(firstRow).filter((anchor) =>
      secondAnchors.has(anchor),
    ).length;
  }

  // @adrian: Similarity is positional rather than a generic fuzzy string
  // distance. An anonymized token matches when both rows use the same type at
  // that position. A static token matches when its original value is equal.
  // The 80% threshold allows small natural variations while the shape filter
  // above keeps the comparison semantically safe.
  function isSimilarAnonymizationRow(firstRow, secondRow) {
    const firstTokens = firstRow.substringsRaw || [];
    const secondTokens = secondRow.substringsRaw || [];
    if (firstTokens.length < 9 || firstTokens.length !== secondTokens.length) {
      return false;
    }

    let compatiblePositions = 0;
    for (let index = 0; index < firstTokens.length; index++) {
      const first = firstTokens[index];
      const second = secondTokens[index];
      const bothAnonymized =
        isAnonymizationType(first.type) && isAnonymizationType(second.type);

      if (
        (bothAnonymized && first.type === second.type) ||
        (!bothAnonymized &&
          !isAnonymizationType(first.type) &&
          !isAnonymizationType(second.type) &&
          normalizeGroupToken(first.value) ===
            normalizeGroupToken(second.value))
      ) {
        compatiblePositions++;
      }
    }

    return compatiblePositions / firstTokens.length >= 0.8;
  }

  function paginateGroups(subtaskGroups, amount) {
    if (!amount) return [];

    const pages = [];
    let currentPage = [];
    let currentCount = 0;

    for (const subtaskGroup of subtaskGroups) {
      for (const group of subtaskGroup.groups) {
        if (currentPage.length && currentCount + 1 > amount) {
          pages.push(currentPage);
          currentPage = [];
          currentCount = 0;
        }

        let pageSubtaskGroup = currentPage.find(
          (pageGroup) => pageGroup.id === subtaskGroup.id,
        );
        if (!pageSubtaskGroup) {
          pageSubtaskGroup = {
            id: subtaskGroup.id,
            name: subtaskGroup.name,
            groups: [],
          };
          currentPage.push(pageSubtaskGroup);
        }

        pageSubtaskGroup.groups.push(group);
        currentCount += 1;
      }
    }

    if (currentPage.length) pages.push(currentPage);
    return pages;
  }

  function getRowsFromGroups(subtaskGroups) {
    const rows = [];
    const seen = new Set();

    for (const subtaskGroup of subtaskGroups) {
      for (const group of subtaskGroup.groups) {
        for (const row of group) {
          if (!seen.has(row.id)) {
            seen.add(row.id);
            rows.push(row);
          }
        }
      }
    }

    return rows;
  }

  function getKeyboardRowKey(subtaskIndex, groupIndex, rowIndex) {
    return `${subtaskIndex}-${groupIndex}-${rowIndex}`;
  }

  function getVisibleKeyboardRows() {
    return groupedRows.flatMap((subtaskGroup, subtaskIndex) =>
      subtaskGroup.groups.flatMap((group, groupIndex) => {
        const rows =
          (expandedGroups[`${subtaskIndex}-${groupIndex}`] ?? false)
            ? group
            : group.slice(0, 1);
        return rows.map((row, rowIndex) => ({
          key: getKeyboardRowKey(subtaskIndex, groupIndex, rowIndex),
          row,
        }));
      }),
    );
  }

  function ensureKeyboardCursor() {
    if (!keyboardNavigationActive) return;
    const rows = getVisibleKeyboardRows();
    const activeRow = rows.find(({ key }) => key === keyboardRowKey);
    if (!activeRow) {
      keyboardRowKey = rows[0]?.key || "";
      keyboardColumnIndex = 0;
      return;
    }
    keyboardColumnIndex = Math.min(
      keyboardColumnIndex,
      Math.max(0, (activeRow.row.substringsRaw?.length || 1) - 1),
    );
  }

  async function revealKeyboardTarget() {
    await tick();
    const target = document.querySelector(
      `[data-keyboard-target="${keyboardRowKey}-${keyboardColumnIndex}"]`,
    );
    target?.scrollIntoView({ block: "nearest", inline: "nearest" });
  }

  function setKeyboardCursor(rowKey, columnIndex = 0) {
    keyboardNavigationActive = true;
    keyboardRowKey = rowKey;
    keyboardColumnIndex = columnIndex;
    keyboardSelectionAnchor = null;
  }

  function selectKeyboardRange(row, startIndex, endIndex) {
    const firstIndex = Math.min(startIndex, endIndex);
    const lastIndex = Math.max(startIndex, endIndex);
    selectedElements = row.substringsRaw
      .slice(firstIndex, lastIndex + 1)
      .map((substring, offset) => {
        const substringIndex = firstIndex + offset;
        return {
          key: getSelectedElementKey(row, substringIndex),
          row,
          substring,
          value: substring.value,
        };
      });
  }

  async function handleKeyboardNavigation(event) {
    if (event.key === "Escape") {
      window.dispatchEvent(new Event("close-anonymization-menu"));
      if (openModal) handleCancelTypeChange();
      return;
    }
    if (
      ![
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Enter",
        " ",
      ].includes(event.key)
    )
      return;
    const target = event.target;
    if (
      target?.matches?.("input, textarea, select, [contenteditable='true']") ||
      target?.closest?.(".options-list, .bx--modal, .paxbot_chat_window")
    )
      return;
    if (
      (event.key === "Enter" || event.key === " ") &&
      target?.closest?.("button")
    )
      return;

    const rows = getVisibleKeyboardRows();
    if (!rows.length) return;
    let rowIndex = rows.findIndex(({ key }) => key === keyboardRowKey);
    if (!keyboardNavigationActive || rowIndex < 0) {
      setKeyboardCursor(rows[0].key);
      event.preventDefault();
      if (event.key === "Enter") {
        await revealKeyboardTarget();
        document
          .querySelector(
            `[data-keyboard-target="${keyboardRowKey}-${keyboardColumnIndex}"] .custom-select`,
          )
          ?.click();
      } else {
        revealKeyboardTarget();
      }
      return;
    }

    const activeRow = rows[rowIndex].row;
    const lastColumn = Math.max(0, (activeRow.substringsRaw?.length || 1) - 1);
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      keyboardSelectionAnchor = null;
      rowIndex = Math.max(
        0,
        Math.min(
          rows.length - 1,
          rowIndex + (event.key === "ArrowDown" ? 1 : -1),
        ),
      );
      setKeyboardCursor(rows[rowIndex].key, 0);
    } else if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      const nextColumnIndex = Math.max(
        0,
        Math.min(
          lastColumn,
          keyboardColumnIndex + (event.key === "ArrowRight" ? 1 : -1),
        ),
      );
      if (event.shiftKey || shiftPressed) {
        if (keyboardSelectionAnchor?.rowKey !== keyboardRowKey) {
          keyboardSelectionAnchor = {
            rowKey: keyboardRowKey,
            columnIndex: keyboardColumnIndex,
          };
        }
        selectKeyboardRange(
          activeRow,
          keyboardSelectionAnchor.columnIndex,
          nextColumnIndex,
        );
      } else {
        keyboardSelectionAnchor = null;
      }
      keyboardColumnIndex = nextColumnIndex;
    } else if (event.key === " " && event.shiftKey) {
      requestToggleSafeTitle(activeRow);
    } else if (event.key === " ") {
      const nextRowId = rows[rowIndex + 1]?.row.id;
      handleMarkRowAsChecked(activeRow);
      await tick();
      const updatedRows = getVisibleKeyboardRows();
      const nextRow =
        updatedRows.find(({ row }) => row.id === nextRowId) ||
        updatedRows[Math.min(rowIndex, updatedRows.length - 1)];
      if (nextRow) setKeyboardCursor(nextRow.key);
    } else {
      document
        .querySelector(
          `[data-keyboard-target="${keyboardRowKey}-${keyboardColumnIndex}"] .custom-select`,
        )
        ?.click();
    }
    event.preventDefault();
    revealKeyboardTarget();
  }

  function getPaxbotContext() {
    const activeRow = getVisibleKeyboardRows().find(
      ({ key }) => key === keyboardRowKey,
    )?.row;
    return {
      page: "Anonymization Check",
      projectId: idproject,
      progress: {
        checkedEntries: checkedStrings,
        totalEntries: totalStrings,
        checkedSubtasks: appsFinished,
        totalSubtasks: totalApps,
      },
      filters: {
        team: selectedTeam || "All teams",
        process: selectedProcess || "All processes",
        subprocess: selectedSubprocess || "All subprocesses",
        task: selectedTask || "All tasks",
        subtask: selectedSubtask || "All subtasks",
        status: selectedOption || "all",
        search: searchQuery || "",
      },
      keyboardShortcuts: {
        upDown:
          "Move to the previous or next entry and start at its leftmost token",
        leftRight: "Move between tokens in the current entry",
        enter: "Open the anonymization type selection",
        space: "Toggle the checked state of the current entry",
      },
      selectedEntry: activeRow
        ? {
            application: activeRow.clearname,
            anonymizedTitle: activeRow.anonymizedString,
            checked: activeRow.check,
          }
        : null,
      visibleEntries: filteredRows.slice(0, 25).map((row) => ({
        application: row.clearname,
        anonymizedTitle: row.anonymizedString,
        checked: row.check,
      })),
    };
  }

  async function requestPaxbotAnswer(question, history, responseLanguage) {
    const response = await fetchWithSession("/api/damprojects/paxbot/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        question,
        history: history.slice(-2),
        context: { ...getPaxbotContext(), responseLanguage },
      }),
    });
    const result = await response.json();
    if (!response.ok || result.status === "error") {
      throw new Error(result.message || "Paxbot request failed");
    }
    return result.answer;
  }

  function toggleGroup(key) {
    expandedGroups = {
      ...expandedGroups,
      [key]: !(expandedGroups[key] ?? false),
    };
  }

  function rowMatchesLFilters(row, ignoreSelectedSubtask = false) {
    const hasLFilter = Boolean(
      selectedProcess ||
        selectedSubprocess ||
        selectedTask ||
        selectedSubtask ||
        selectedTeam ||
        selectedAssignedOption,
    );

    // "All" must not depend on whether the filter catalog contains the
    // subtasks returned by the anonymization endpoint.
    if (!hasLFilter) return true;
    if (!isAssignedRow(row)) return false;

    return row.subtasks.some((subtask) => {
      const subtaskData = listOfSubtasks.find(
        (candidate) => String(candidate.id) === String(subtask.id),
      );
      if (!subtaskData) return false;

      const task = listOfTasks.find(
        (candidate) => String(candidate.id) === String(subtaskData.task_id),
      );
      const subprocess = listOfSubprocesses.find(
        (candidate) => String(candidate.id) === String(task?.subprocess_id),
      );
      const process = processes.find(
        (candidate) => String(candidate.id) === String(subprocess?.process_id),
      );

      if (selectedProcess && String(process?.id) !== String(selectedProcess))
        return false;
      if (
        selectedSubprocess &&
        String(subprocess?.id) !== String(selectedSubprocess)
      )
        return false;
      if (selectedTask && String(task?.id) !== String(selectedTask))
        return false;
      if (
        !ignoreSelectedSubtask &&
        selectedSubtask &&
        String(subtaskData.id) !== String(selectedSubtask)
      )
        return false;

      const activeRecordings = (subtaskData.recordings || []).filter(
        (recording) =>
          listOfRecordings.some(
            (projectRecording) =>
              String(projectRecording.recorderid) ===
                String(recording.recording_id) && !projectRecording.deleted,
          ),
      );

      if (
        selectedTeam &&
        !activeRecordings.some((recording) =>
          listOfRecordings.some(
            (projectRecording) =>
              String(projectRecording.recorderid) ===
                String(recording.recording_id) &&
              String(projectRecording.teamid) === String(selectedTeam) &&
              !projectRecording.deleted,
          ),
        )
      )
        return false;

      if (selectedAssignedOption) {
        const registrationCount = activeRecordings.length;
        if (
          selectedAssignedOption === "enough_registrations" &&
          registrationCount < 10
        )
          return false;
        if (
          selectedAssignedOption === "limited_registrations" &&
          (registrationCount === 0 || registrationCount >= 10)
        )
          return false;
        if (
          ["assigned", "not_assigned"].includes(selectedAssignedOption) &&
          ((selectedAssignedOption === "assigned" && registrationCount === 0) ||
            (selectedAssignedOption === "not_assigned" &&
              registrationCount > 0))
        )
          return false;
        if (
          selectedAssignedOption === "no_registrations" &&
          registrationCount !== 0
        )
          return false;
      }

      return true;
    });
  }

  async function getAnonymizationAsisstant(scope = "assigned") {
    if (loadedRowsByScope[scope]) return;

    isLoading = true;
    const generation = ++loadGeneration;

    try {
      const response = await fetchWithSession(
        `/api/damprojects/anonymization-assistant-preview-scoped?project_stage_id=${projectStageId}&scope=${scope}`,
      );
      const scopedData = await response.json();
      const data = scopedData.rows || [];
      const subtaskMappings = scopedData.subtasks || {};
      if (!appNameMappings) {
        const appNameResponse = await fetchWithSession(
          `/api/damprojects/getAppnameMapping`,
        );
        appNameMappings = await appNameResponse.json();
      }

      if (generation !== loadGeneration) return;
      console.log("Anonymization Assistant Data:", data);
      const rows = setDataRows(data, subtaskMappings, appNameMappings).sort(
        (a, b) => {
          const lenDiff = b.fullstringLength - a.fullstringLength;
          if (lenDiff !== 0) return lenDiff;
          return a.clearname.localeCompare(b.clearname);
        },
      );
      loadedRowsByScope = { ...loadedRowsByScope, [scope]: rows };
      if (scope === "assigned") assignedRows = rows;
      if (scope === "global") allRows = rows;
    } catch (error) {
      console.error("Error fetching Anonymization Assistant data:", error);
    } finally {
      if (generation === loadGeneration) isLoading = false;
    }
  }

  function updateAnonymization(
    row,
    justChecked = false,
    triggerWindowtitleRule = false,
  ) {
    const id = row.id;
    const anonymized = row.anonymizedString;
    const checked = row.check;
    const body = justChecked ? { checked } : { anonymized, checked };
    return fetchWithSession(
      `/api/damprojects/anonymization-assistant-preview/${id}`,
      {
        method: "PATCH",
        body: JSON.stringify(body),
      },
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.ok) {
          listOfRows = listOfRows.map((r) => {
            if (r.id === id) {
              return {
                ...r,
                anonymizedString: data.data.anonymized,
                check: data.data.checked,
              };
            }
            return r;
          });
          updatePercentageBars();
          if (triggerWindowtitleRule && checked) {
            runWindowtitleRule(row);
          }
        } else {
          if (triggerWindowtitleRule) {
            windowtitleRuleModalOpen = false;
            windowtitleRuleLoading = false;
            windowtitleRulePreview = null;
          }
        }
      })
      .catch((err) => {
        if (triggerWindowtitleRule) {
          windowtitleRuleModalOpen = false;
          windowtitleRuleLoading = false;
          windowtitleRulePreview = null;
        }
        console.error("Error updating Anonymization Assistant data:", err);
      });
  }

  async function runWindowtitleRule(row, sourceRows = [row], showModal = true) {
    clearTimeout(windowtitleRuleLoadingTimer);
    if (showModal) {
      windowtitleRuleLoadingTimer = setTimeout(
        () => openWindowtitleRulePreview(row, sourceRows),
        200,
      );
    }
    try {
      const previewResponse = await fetchWithSession(
        "/api/damprojects/anonymization-windowtitle-rule/preview",
        {
          method: "POST",
          body: JSON.stringify({
            source_id: row.id,
            source_ids: sourceRows.map((member) => member.id),
            sections: (row.substringsRaw || []).map((substring) => ({
              value: substring.value,
              type: substring.type,
              is_anonymized: isAnonymizationType(substring.type),
            })),
          }),
        },
      );
      const preview = await previewResponse.json();
      clearTimeout(windowtitleRuleLoadingTimer);
      if (!previewResponse.ok) {
        throw new Error(
          "Unable to generate a window-title rule. Please try again later.",
        );
      }
      if (!preview.eligible) {
        windowtitleRuleModalOpen = false;
        windowtitleRuleLoading = false;
        windowtitleRulePreview = null;
        return;
      }
      windowtitleRulePreview = {
        source: row,
        sourceIds: sourceRows.map((member) => member.id),
        preview,
      };
      if (!showModal || !/<<<[A-Z]+>>>/.test(row.anonymizedString || "")) {
        await applyWindowtitleRule();
        return;
      }
      windowtitleRuleLoading = false;
      windowtitleRuleModalOpen = true;
    } catch (error) {
      clearTimeout(windowtitleRuleLoadingTimer);
      windowtitleRuleModalOpen = false;
      windowtitleRuleLoading = false;
      console.error("Error generating window-title regex:", error);
    }
  }

  async function applyWindowtitleRule() {
    const { source, preview } = windowtitleRulePreview || {};
    if (!source || !preview) return;
    windowtitleRuleLoading = true;
    try {
      const applyResponse = await fetchWithSession(
        "/api/damprojects/anonymization-windowtitle-rule/apply",
        {
          method: "POST",
          body: JSON.stringify({
            source_id: source.id,
            source_ids: windowtitleRulePreview.sourceIds || [source.id],
            search: preview.search,
            refinement_round: preview.refinement_round,
            selected_ids: (preview.candidates || [])
              .filter((candidate) => candidate.selected)
              .map((candidate) => candidate.id),
            rejected_ids: (preview.candidates || [])
              .filter((candidate) => !candidate.selected)
              .map((candidate) => candidate.id),
          }),
        },
      );
      const applied = await applyResponse.json();
      if (applyResponse.ok && applied.requires_review) {
        windowtitleRulePreview = { source, preview: applied };
        windowtitleRuleLoading = false;
        return;
      }
      if (!applyResponse.ok || !applied.success) {
        throw new Error(
          "Unable to apply the window-title rule. Please try again later.",
        );
      }

      mergeUpdatedRows(applied.updated_rows || []);
      windowtitleRuleModalOpen = false;
      windowtitleRuleLoading = false;
      windowtitleRulePreview = null;
    } catch (error) {
      windowtitleRuleLoading = false;
      console.error("Error applying window-title regex:", error);
    }
  }

  // Applies the rows changed by the backend locally. A full reload after every
  // rule shows the loading screen and loses the current page and filters.
  function mergeUpdatedRows(updatedRows) {
    const updates = new Map(
      updatedRows.map((update) => [String(update.id), update]),
    );
    const applyUpdate = (row) => {
      const update = updates.get(String(row.id));
      if (!update) return row;
      row.anonymizedString = update.anonymized;
      row.check = update.checked;
      rebuildSubstrings(row);
      return row;
    };
    // In place, so the scope block does not reassign listOfRows.
    Object.values(loadedRowsByScope).forEach((rows) =>
      rows?.forEach(applyUpdate),
    );
    listOfRows = listOfRows.map(applyUpdate);
    updatePercentageBars();
  }

  function openWindowtitleRulePreview(row, sourceRows = [row]) {
    windowtitleRulePreview = {
      source: row,
      sourceIds: sourceRows.map((member) => member.id),
      preview: null,
    };
    windowtitleRuleLoading = true;
    windowtitleRuleModalOpen = true;
  }

  function updateMultipleAnonymizations(rows) {
    const rowsToUpdate = rows.map((row) => {
      return {
        id: row.id,
        anonymized: row.anonymizedString,
        checked: row.check,
      };
    });
    fetchWithSession(
      `/api/damprojects/anonymization-assistant-preview?project_stage_id=${projectStageId}`,
      {
        method: "POST",
        body: JSON.stringify({ rowsToUpdate }),
      },
    )
      .then((response) => response.json())
      .then((data) => {
        console.log({ data });
      })
      .catch((error) => {
        console.error("Error updating Anonymization Assistant data:", error);
      });
  }

  function getApplications(listOfRows) {
    return listOfRows
      .map((row) => row.clearname || row.applicationname)
      .filter((value, index, self) => self.indexOf(value) === index)
      .map((app) => ({ key: app, value: app, id: app, text: app }))
      .sort((a, b) => a.value.localeCompare(b.value));
  }

  function getAnonymizationGroupKey(row) {
    const tokens = row.substringsRaw || [];
    const structure = tokens.map((substring) => {
      if (isAnonymizationType(substring.type)) {
        return `anon:${substring.type}`;
      }

      return `text:${normalizeGroupToken(substring.value)}`;
    });

    return `${getAnonymizationAppKey(row)}:${tokens.length}:${structure.join("|")}`;
  }

  function getAnonymizationAppKey(row) {
    return normalizeGroupToken(
      row.clearname || row.applicationname || "unknown-app",
    );
  }

  function isAnonymizationType(type) {
    return Object.values(anontypeOptionsMap)
      .flatMap((category) => category.options || [])
      .some((option) => option.value === type);
  }

  function normalizeGroupToken(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function normalizeWindowTitleKey(value) {
    return String(value || "")
      .normalize("NFKC")
      .replace(
        /[\u0000-\u001F\u007F-\u009F\u200B-\u200F\u202A-\u202E\u2060\uFEFF]/g,
        "",
      )
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function setDataRows(data, subtaskMappings = {}, appNameMappings = []) {
    const clearnameByApplication = new Map(
      appNameMappings
        .filter((mapping) => mapping?.applicationname)
        .map((mapping) => [String(mapping.applicationname), mapping.clearname]),
    );

    return data
      .map((item, index) => {
        const technicalAppName = item.applicationname || "";
        const appName =
          item.clearname ||
          clearnameByApplication.get(String(technicalAppName)) ||
          technicalAppName ||
          "Unknown App";
        const mappedSubtasks = subtaskMappings[String(item.id)] || [];
        const subtasks = mappedSubtasks.length
          ? mappedSubtasks
          : [{ id: "unassigned", name: "Unassigned" }];
        const words = splitString(item.windowtitle);
        const anonymizedWords = splitString(item.anonymized);
        const spaceBoundaries = getSpaceBoundaryIndices(item.windowtitle);
        if (words.length === 1 && words[0] === "") {
          return null;
        }
        const substrings = words.map((word, wordIndex) => {
          let rawString = anonymizedWords[wordIndex] || word;
          let type = rawString;
          let anonHasTrailingSpace = false;
          const match = rawString.match(/<<<([^>]+)>>>/);
          if (match) {
            type = match[1];
            anonHasTrailingSpace = rawString.endsWith(" ");
          } else {
            type = type.replace(/<<<|>>>/g, "");
          }
          return {
            id: wordIndex,
            type: type,
            value: word,
            spaceAfter: spaceBoundaries.has(wordIndex),
            anonHasTrailingSpace: anonHasTrailingSpace,
          };
        });
        return {
          id: item.id || index,
          clearname: appName.trim(),
          subtasks,
          check: item.checked || false,
          substringsRaw: substrings,
          fullstringLength: item.windowtitle.length || 0,
          anonymizedString: item.anonymized || "",
          windowtitleString: item.windowtitle || "",
          safeStatus: item.safe_status || null,
        };
      })
      .filter((item) => item !== null);
  }

  function isAssignedRow(row) {
    return row.subtasks.some((subtask) => String(subtask.id) !== "unassigned");
  }

  function isAnonymizedState(type, originalValue) {
    return isAnonymizationType(type) || type !== originalValue;
  }

  function getPendingTargetType(originalValue) {
    return isAnonymizationType(pendingChangeType)
      ? pendingChangeType
      : originalValue;
  }

  function joinAnonymized(substrings) {
    return substrings
      .map((s) => {
        const isAnonType = Object.values(anontypeOptionsMap)
          .flatMap((col) => col.options || [])
          .some((option) => option.value === s.type);

        let part;
        if (isAnonType) {
          const hasSpace =
            s.anonHasTrailingSpace ||
            s.value.endsWith(" ") ||
            s.value.endsWith("_");
          part = `<<<${s.type}>>>${hasSpace ? " " : ""}`;
        } else {
          part = s.type;
        }
        if (s.spaceAfter) {
          part += "<<<space>>>";
        }
        return part;
      })
      .join("");
  }

  function updateAppFinished() {
    const finishedAppsSet = new Set();
    for (let row of listOfRows) {
      if (row.check) {
        const allRowsForApp = listOfRows.filter(
          (r) => r.clearname === row.clearname,
        );
        if (allRowsForApp.every((r) => r.check)) {
          finishedAppsSet.add(row.clearname);
        }
      }
    }
    appsFinished = finishedAppsSet.size;
  }

  function updateCheckedStrings() {
    checkedStrings = listOfRows.filter((row) => row.check).length;
  }

  function normalizeTitle(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function isUnchangedRow(row) {
    return (
      normalizeTitle(row.anonymizedString) ===
      normalizeTitle(row.windowtitleString)
    );
  }

  function safeTitleTooltip(row) {
    if (row.safeStatus === "approved") return "Approved as standard title";
    if (row.safeStatus === "pending") return "Remove standard title proposal";
    if (!isUnchangedRow(row))
      return "Only unchanged titles can be standard titles";
    return "Standard title of the program?";
  }

  // Proposing a title asks for confirmation first, withdrawing does not.
  function requestToggleSafeTitle(row, group = [row]) {
    if (row.safeStatus || !isUnchangedRow(row)) {
      handleToggleSafeTitle(row, group);
      return;
    }
    pendingSafeTitle = { row, group };
    safeTitleModalOpen = true;
  }

  function confirmSafeTitle() {
    const pending = pendingSafeTitle;
    safeTitleModalOpen = false;
    pendingSafeTitle = null;
    if (pending) handleToggleSafeTitle(pending.row, pending.group);
  }

  function cancelSafeTitle() {
    safeTitleModalOpen = false;
    pendingSafeTitle = null;
  }

  // Proposes a generic, unchanged title as safe for all projects. An admin
  // approves it in the admin settings, approved titles are pre-checked in new
  // projects. Approved titles can only be removed in the admin settings.
  // A group passed here always shares the same window title.
  async function handleToggleSafeTitle(row, group = [row]) {
    if (row.safeStatus === "approved") return;
    const withdraw = row.safeStatus === "pending";
    if (!withdraw && !isUnchangedRow(row)) return;
    if (!withdraw && group.length > 1) {
      const unchecked = group.filter((r) => !r.check);
      unchecked.forEach((r) => (r.check = true));
      if (unchecked.length) {
        Promise.all(unchecked.map((r) => updateAnonymization(r, true))).then(
          () => runWindowtitleRule(row, group),
        );
        updatePercentageBars();
      }
    } else if (!withdraw && !row.check) handleMarkRowAsChecked(row);
    const response = await fetchWithSession(
      withdraw
        ? `/api/damprojects/safe-windowtitles/propose/${row.id}`
        : "/api/damprojects/safe-windowtitles/propose",
      withdraw
        ? { method: "DELETE" }
        : { method: "POST", body: JSON.stringify({ preview_id: row.id }) },
    );
    if (!response.ok) return;
    const data = await response.json();
    const safeStatus = data.safe_status || null;
    const ids = new Set(group.map((r) => r.id));
    group.forEach((r) => (r.safeStatus = safeStatus));
    // The groups are rebuilt from listOfRows, so the state has to be stored there.
    listOfRows = listOfRows.map((r) =>
      ids.has(r.id) ? { ...r, safeStatus } : r,
    );
    filteredRows = [...filteredRows];
  }

  function handleMarkRowAsChecked(row) {
    const newState = !row.check;
    row.check = newState;
    updateAnonymization(row, true, newState);
    filteredRows = [...filteredRows];
    updatePercentageBars();
  }

  async function handleMarkAllAsChecked() {
    let count = 0;
    const checkedRows = [];
    const updates = [];
    for (let row of filteredRows) {
      if (
        count >= parseInt(selectedAmountItems) ||
        count >= filteredRows.length
      )
        break;
      if (!row.check) {
        row.check = true;
        count++;
        checkedRows.push(row);
        updates.push(updateAnonymization(row, true));
      }
    }
    await Promise.all(updates);
    for (const row of checkedRows) await runWindowtitleRule(row, [row], false);

    if (selectedOption !== "unchecked") {
      if (startIndex + 1 < totalPages) {
        startIndex += 1;
      } else {
        navigateSelectedSubtask(1, false);
      }
    }
    filteredRows = [...filteredRows];

    // updateMultipleAnonymizations(filteredRows);

    updatePercentageBars();
  }

  function handleMoveToNextPage() {
    if (startIndex + 1 < totalPages) {
      startIndex += 1;
    }
  }

  function handleMoveToPreviousPage() {
    if (startIndex > 0) {
      startIndex -= 1;
    }
  }

  function handleMoveToNextTask() {
    navigateSelectedSubtask(1);
  }

  function navigateSelectedSubtask(direction, wrap = true) {
    const options = taskOrderedSubtasks;
    if (options.length < 2) return;

    const currentIndex = options.findIndex(
      (option) => String(option.id) === String(selectedSubtask),
    );
    const requestedIndex = currentIndex + direction;
    if (!wrap && (requestedIndex < 0 || requestedIndex >= options.length))
      return;
    const nextIndex = (requestedIndex + options.length) % options.length;
    startIndex = 0;
    selectedSubtask = options[nextIndex].id;
  }

  function findGroupForRow(row) {
    for (const subtaskGroup of groupedRows) {
      for (const group of subtaskGroup.groups) {
        if (
          group.length > 1 &&
          group.some((candidate) => candidate.id === row.id)
        ) {
          return group;
        }
      }
    }
    return null;
  }

  function handleTypeChanged(row, substring, substringIndex, oldType) {
    if (selectedElements.length > 1) {
      applyTypeToSelectedSubstrings(substring.type);
      return;
    }

    const group = findGroupForRow(row);
    if (!group) {
      row.anonymizedString = joinAnonymized(row.substringsRaw);
      if (row.check) row.check = false;
      updateAnonymization(row);
      listOfRows = [...listOfRows];
      filteredRows = [...filteredRows];
      updatePercentageBars();
      return;
    }

    const requestedType = substring.type;
    pendingOriginalType = oldType;
    pendingOriginalAnonymized = row.anonymizedString;
    pendingOriginalCheck = row.check;
    pendingSubstring = substring;
    pendingSubstringIndex = substringIndex;
    pendingGroup = [...group];
    const orderedPreviewGroup = [
      row,
      ...group.filter((previewRow) => previewRow.id !== row.id),
    ];
    pendingPreviewRows = orderedPreviewGroup.slice(0, 3).map((previewRow) => ({
      isSelected: previewRow.id === row.id,
      currentType:
        previewRow.id === row.id
          ? oldType
          : previewRow.substringsRaw[substringIndex]?.type || "",
      originalValue: previewRow.substringsRaw[substringIndex]?.value || "",
    }));

    // Do not mutate the visible row until the user confirms the modal action.
    // The select component has already applied the tentative value locally, so
    // restore the original state while the decision is pending.
    pendingChangeType = requestedType;
    substring.type = oldType;
    row.anonymizedString = pendingOriginalAnonymized;
    row.check = pendingOriginalCheck;

    rowToChange = row;
    pendingChangeValue = substring.value;
    openModal = true;
  }

  function getSelectedElementKey(row, substringIndex) {
    // Substrings are not persisted with an id, so their position is the stable
    // discriminator within a window title for the temporary UI selection.
    return `${row.id}:${substringIndex}`;
  }

  function handleSubstringSelection(row, substring, substringIndex, event) {
    const shiftKey = Boolean(
      event?.detail?.shiftKey || event?.shiftKey || shiftPressed,
    );
    const selectedElement = {
      key: getSelectedElementKey(row, substringIndex),
      row,
      substring,
      value: substring.value,
    };
    const selectedIndex = selectedElements.findIndex(
      (selected) => selected.key === selectedElement.key,
    );
    if (shiftKey) {
      if (selectedIndex >= 0) {
        selectedElements = selectedElements.filter(
          (_, index) => index !== selectedIndex,
        );
      } else {
        selectedElements = [...selectedElements, selectedElement];
      }
      return;
    }
    selectedElements = [selectedElement];
  }

  function handleSelectionOutsideMouseDown(event) {
    const target = event.target;
    if (target?.closest(".action_wrapper")) {
      selectedElements = [];
      return;
    }
    if (!target?.closest(".anon-element")) {
      selectedElements = [];
    }
  }

  function applyTypeToSelectedSubstrings(newType) {
    const changedRows = new Map();

    for (const { row, substring } of selectedElements) {
      row.substringsRaw = row.substringsRaw.map((currentSubstring) => {
        if (currentSubstring === substring) {
          return { ...currentSubstring, type: newType };
        }
        return currentSubstring;
      });
      row.anonymizedString = joinAnonymized(row.substringsRaw);
      if (row.check) row.check = false;
      changedRows.set(row.id, row);
    }

    for (const row of changedRows.values()) {
      updateAnonymization(row);
    }
    listOfRows = [...listOfRows];
    filteredRows = [...filteredRows];
    updatePercentageBars();
    selectedElements = [];
  }

  function removeSelectedAnonymizations() {
    const changedRows = new Map();

    for (const { row, substring } of selectedElements) {
      row.substringsRaw = row.substringsRaw.map((currentSubstring) => {
        if (currentSubstring === substring) {
          return { ...currentSubstring, type: currentSubstring.value };
        }
        return currentSubstring;
      });
      row.anonymizedString = joinAnonymized(row.substringsRaw);
      if (row.check) row.check = false;
      changedRows.set(row.id, row);
    }

    for (const row of changedRows.values()) {
      updateAnonymization(row);
    }
    listOfRows = [...listOfRows];
    filteredRows = [...filteredRows];
    updatePercentageBars();
    selectedElements = [];
  }

  function handleCancelTypeChange() {
    if (pendingSubstring && rowToChange) {
      pendingSubstring.type = pendingOriginalType;
      rowToChange.anonymizedString = pendingOriginalAnonymized;
      rowToChange.check = pendingOriginalCheck;
      filteredRows = [...filteredRows];
      updatePercentageBars();
    }
    openModal = false;
    pendingChangeType = "";
    pendingChangeValue = "";
    pendingSubstring = null;
    pendingSubstringIndex = -1;
    pendingGroup = null;
    pendingPreviewRows = [];
    rowToChange = null;
  }

  function handleChangeTypeForGroup() {
    const rowsToUpdate = [];

    for (const row of pendingGroup || []) {
      const substring = row.substringsRaw[pendingSubstringIndex];
      if (!substring || substring.type === pendingChangeType) continue;
      const targetType = getPendingTargetType(substring.value);

      row.substringsRaw = row.substringsRaw.map((current, index) =>
        index === pendingSubstringIndex
          ? { ...current, type: targetType }
          : current,
      );
      row.anonymizedString = joinAnonymized(row.substringsRaw);
      if (row.check) row.check = false;
      rowsToUpdate.push(row);
    }

    for (const row of rowsToUpdate) updateAnonymization(row);
    listOfRows = [...listOfRows];
    filteredRows = [...filteredRows];
    updatePercentageBars();
    openModal = false;
    pendingChangeType = "";
    pendingChangeValue = "";
    pendingSubstring = null;
    pendingSubstringIndex = -1;
    pendingGroup = null;
    pendingPreviewRows = [];
    rowToChange = null;
  }

  function handleChangeTypeForOneRow() {
    if (pendingSubstring && rowToChange) {
      pendingSubstring.type = getPendingTargetType(pendingSubstring.value);
      rowToChange.anonymizedString = joinAnonymized(rowToChange.substringsRaw);
      if (rowToChange.check) rowToChange.check = false;
      updateAnonymization(rowToChange);
    }
    openModal = false;
    pendingChangeType = "";
    pendingChangeValue = "";
    pendingSubstring = null;
    pendingSubstringIndex = -1;
    pendingGroup = null;
    pendingPreviewRows = [];
    listOfRows = [...listOfRows];
    filteredRows = [...filteredRows];
    rowToChange = null;
  }

  function handleSliced(row, substring, event) {
    const { slices } = event.detail;
    const slicedValue = slices.join("<<<space>>>");

    // Replace only the sliced substring's value in the full windowtitle
    const newWindowtitle = row.windowtitleString.replace(
      substring.value,
      slicedValue,
    );
    // Do the same for anonymized, replacing the corresponding part
    const newAnonymized = row.anonymizedString.replace(
      substring.value,
      slicedValue,
    );

    fetchWithSession(
      `/api/damprojects/anonymization-assistant-preview/${row.id}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          windowtitle: newWindowtitle,
          anonymized: newAnonymized,
          checked: row.check,
        }),
      },
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.ok) {
          row.windowtitleString = data.data.windowtitle || newWindowtitle;
          row.anonymizedString = data.data.anonymized || newAnonymized;
          rebuildSubstrings(row);
          listOfRows = [...listOfRows];
          filteredRows = [...filteredRows];
          successMsg = "Element sliced successfully.";
        }
      })
      .catch((err) => {
        console.error("Error slicing element:", err);
      });
  }

  function rebuildSubstrings(row) {
    const newWords = splitString(row.windowtitleString);
    const newAnonWords = splitString(row.anonymizedString);
    const newBoundaries = getSpaceBoundaryIndices(row.windowtitleString);
    row.substringsRaw = newWords.map((word, i) => {
      let rawString = newAnonWords[i] || word;
      let type = rawString;
      let anonHasTrailingSpace = false;
      const match = rawString.match(/<<<([^>]+)>>>/);
      if (match) {
        type = match[1];
        anonHasTrailingSpace = rawString.endsWith(" ");
      } else {
        type = type.replace(/<<<|>>>/g, "");
      }
      return {
        id: i,
        type,
        value: word,
        spaceAfter: newBoundaries.has(i),
        anonHasTrailingSpace: anonHasTrailingSpace,
      };
    });
  }

  function handleUnjoinSpace(row, substringIndex) {
    const sub = row.substringsRaw[substringIndex];
    const nextSub = row.substringsRaw[substringIndex + 1];
    if (!sub || !nextSub) return;

    // Merge the two values back together
    const mergedValue = sub.value + nextSub.value;

    // Remove <<<space>>> between these two substrings in the full strings
    const newWindowtitle = row.windowtitleString.replace(
      sub.value + "<<<space>>>" + nextSub.value,
      mergedValue,
    );
    const newAnonymized = row.anonymizedString.replace(
      sub.type + "<<<space>>>" + nextSub.type,
      sub.type + nextSub.type,
    );

    fetchWithSession(
      `/api/damprojects/anonymization-assistant-preview/${row.id}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          windowtitle: newWindowtitle,
          anonymized: newAnonymized,
          checked: row.check,
        }),
      },
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.ok) {
          row.windowtitleString = data.data.windowtitle || newWindowtitle;
          row.anonymizedString = data.data.anonymized || newAnonymized;
          rebuildSubstrings(row);
          listOfRows = [...listOfRows];
          filteredRows = [...filteredRows];
        }
      })
      .catch((err) => {
        console.error("Error joining elements:", err);
      });
  }

  function updatePercentageBars() {
    updateAppFinished();
    updateCheckedStrings();
  }

  onMount(async () => {
    try {
      const response = await fetchWithSession(
        `/api/damprojects/DAMProject/${idproject}/progress`,
        { method: "GET" },
      );
      const data = await response.json();
      projectStageId = data.find(
        (stage) => stage.stage === "TASK_REGISTRATION",
      )?.id;
      if (!projectStageId) isLoading = false;
    } catch (error) {
      isLoading = false;
      console.error("Error loading anonymization check:", error);
    }
  });

  $: if (groupedRows && expandedGroups) ensureKeyboardCursor();
</script>

<svelte:window
  on:keydown={(event) => {
    if (event.key === "Shift") shiftPressed = true;
    handleKeyboardNavigation(event);
  }}
  on:keyup={(event) => {
    if (event.key === "Shift") {
      shiftPressed = false;
      keyboardSelectionAnchor = null;
    }
  }}
  on:blur={() => (shiftPressed = false)}
  on:mousedown={handleSelectionOutsideMouseDown}
/>

<Header
  section="Anonymization Check"
  area="Discovery"
  breadcrumb="Anonymization Check"
  tooltipText="Review captured task registration data and confirm that required anonymization checks are complete."
>
  <div class="header-status">
    <PercentageBar
      total={totalApps}
      totalChecked={appsFinished}
      text="Subtasks checked"
    />
    <PercentageBar
      total={totalStrings}
      totalChecked={checkedStrings}
      text="Entries checked"
    />
    <Button
      kind={paxbotOpen ? "primary" : "secondary"}
      size="field"
      icon={BOT_WHITE_ICON}
      iconDescription="Anonymization assistant"
      on:click={() => (paxbotOpen = !paxbotOpen)}
    />
    {#if $role?.role === "admin"}
      <ProjectStepActions
        {idproject}
        step={completionStep}
        stage={completionStage}
        showGoBackButton={false}
        text="Complete Anonymization Check"
        size="sm"
        completionWarning="This marks the anonymization check phase as complete. This action cannot be undone."
      />
    {/if}
  </div>
</Header>

<SectionWrapper
  fullscreen={true}
  seamless
  fitScreen={true}
  loading={isLoading}
  loadingTitle="Preparing your review."
  loadingHint="Please wait a moment."
>
  <div slot="main" class="anonymization-section">
    <div class="content_wrapper">
      <AnonymizationReviewFilters
        {idproject}
        bind:selectedProcess
        bind:selectedSubprocess
        bind:selectedTask
        bind:selectedSubtask
        bind:selectedTeam
        bind:selectedAssignedOption
        bind:selectedLevel={selectedReviewType}
        bind:selectedShow={selectedOption}
        bind:selectedApplications={selectedApplicationIds}
        bind:selectedSort={sortByOption}
        bind:selectedPageSize={selectedAmountItems}
        showOptions={selectOptions}
        applicationOptions={appOptions}
        applicationLabel={selectedApplicationLabel}
        sortOptions={sortByOptions}
        pageSizeOptions={amountItemsOptions}
        subtaskNavigationEnabled={availableSubtasks.length > 1}
        onNavigateSubtask={navigateSelectedSubtask}
        onSearch={(value) => (searchQuery = value)}
      />
      {#if isLoading}
        <div class="loading_wrapper">
          <Loading small withOverlay={false} description="Loading entries" />
          <span>Loading entries...</span>
        </div>
      {:else if listOfRows.length > 0 && hasActiveFilters && filteredTotalCount === 0}
        <div class="empty-filter-state">
          <p>No data was collected for the selected filters.</p>
          <Button
            text="Open Registration Dashboard in new tab"
            large
            kind="secondary"
            on:click={() =>
              window.open(
                `${ROUTES.processRegistration.dashboard}?idproject=${idproject}`,
                "_blank",
                "noopener,noreferrer",
              )}
          />
        </div>
      {:else}
        <div class="main">
          <section class="rows-container">
            {#each groupedRows as subtaskGroup, subtaskIndex}
              <div class="subtask-group">
                {#each subtaskGroup.groups as group, groupIndex}
                  {@const firstRow = group[0]}
                  {@const isGrouped = group.length > 1}
                  {@const isExactWindowTitleGroup =
                    isGrouped && group.exactWindowTitleGroup}
                  {@const groupApps = [
                    ...new Set(
                      group.map(
                        (row) =>
                          row.clearname || row.applicationname || "Unknown App",
                      ),
                    ),
                  ].sort((first, second) => first.localeCompare(second))}
                  {@const displayedApp =
                    groupApps.length > 1
                      ? `${groupApps.length} Apps`
                      : groupApps[0]}
                  {@const isExpandable = isGrouped && !isExactWindowTitleGroup}
                  {@const groupChecked = group.every((row) => row.check)}
                  {@const groupKey = `${subtaskIndex}-${groupIndex}`}
                  <div class="group-wrapper" class:has-group={isExpandable}>
                    {#if isExpandable}
                      <div class="group-toggle">
                        <Button
                          fixedWidth
                          kind="secondary"
                          size="lg"
                          icon={(expandedGroups[groupKey] ?? false)
                            ? CHEVRON_UP_ICON
                            : CHEVRON_DOWN_ICON}
                          iconDescription={(expandedGroups[groupKey] ?? false)
                            ? "Collapse group"
                            : "Expand group"}
                          on:click={() => toggleGroup(groupKey)}
                        />
                      </div>
                    {/if}
                    <div class="group-rows">
                      <div
                        class="row-wrapper"
                        class:keyboard-row-active={keyboardNavigationActive &&
                          keyboardRowKey ===
                            getKeyboardRowKey(subtaskIndex, groupIndex, 0)}
                      >
                        <div class="row" class:checked={groupChecked}>
                          {#if showApplicationName}
                            <AnonElement
                              readElement="Application"
                              anontype={displayedApp}
                              appTitle={groupApps.join(", ")}
                              appIcon={groupApps.length === 1
                                ? `/api/damprojects/app-icon?application=${encodeURIComponent(groupApps[0])}`
                                : ""}
                              firstElement={true}
                            ></AnonElement>
                          {/if}
                          {#each firstRow.substringsRaw as substring, i}
                            <div
                              class="keyboard-target"
                              class:keyboard-target-active={keyboardNavigationActive &&
                                keyboardRowKey ===
                                  getKeyboardRowKey(
                                    subtaskIndex,
                                    groupIndex,
                                    0,
                                  ) &&
                                keyboardColumnIndex === i}
                              data-keyboard-target={`${getKeyboardRowKey(subtaskIndex, groupIndex, 0)}-${i}`}
                              on:mousedown={() =>
                                setKeyboardCursor(
                                  getKeyboardRowKey(
                                    subtaskIndex,
                                    groupIndex,
                                    0,
                                  ),
                                  i,
                                )}
                            >
                              <AnonElement
                                readElement={substring.value}
                                bind:anontype={substring.type}
                                selected={selectedElementKeys.includes(
                                  getSelectedElementKey(firstRow, i),
                                )}
                                multiSelected={selectedElements.length > 1}
                                {selectedElementValues}
                                onSelection={(event) =>
                                  handleSubstringSelection(
                                    firstRow,
                                    substring,
                                    i,
                                    event,
                                  )}
                                {anontypeOptionsMap}
                                removeAnonType={substring.value}
                                on:typeChanged={(e) =>
                                  handleTypeChanged(
                                    firstRow,
                                    substring,
                                    i,
                                    e.detail.oldValue,
                                  )}
                                on:removeSelected={removeSelectedAnonymizations}
                                on:sliced={(e) =>
                                  handleSliced(firstRow, substring, e)}
                                hideLastChar={substring.value.length === 1
                                  ? false
                                  : i < firstRow.substringsRaw.length - 1}
                              ></AnonElement>
                            </div>
                            {#if i < firstRow.substringsRaw.length - 1 && substring.value.length > 1 && substring.value.endsWith("_")}
                              <span class="underscore-separator">_</span>
                            {/if}
                            {#if substring.spaceAfter}
                              <button
                                class="join-icon-btn"
                                title="Click to rejoin these elements"
                                on:click={() => handleUnjoinSpace(firstRow, i)}
                              >
                                <img
                                  src={JOIN_INNER_ALT_ICON}
                                  alt="Join elements"
                                  class="join-icon"
                                />
                              </button>
                            {/if}
                          {/each}
                          <span
                            class="row-end-border"
                            class:checked={groupChecked}
                          ></span>
                          {#if isGrouped && !isExactWindowTitleGroup}
                            <span
                              class="group-count-badge"
                              title={`${group.length} entries represented by this row`}
                              >{group.length}</span
                            >
                          {/if}
                          <div class="action-buttons-container">
                            <Button
                              fixedWidth
                              kind="secondary"
                              size="lg"
                              icon={groupChecked ? CLOSE_ICON : CHECK_ICON}
                              iconDescription={groupChecked
                                ? "Mark as not checked"
                                : "Mark as checked"}
                              on:click={() => {
                                if (isGrouped) {
                                  const newState = !groupChecked;
                                  const updates = [];
                                  group.forEach((r) => {
                                    if (r.check !== newState) {
                                      r.check = newState;
                                      updates.push(
                                        updateAnonymization(r, true),
                                      );
                                    }
                                  });
                                  if (newState) {
                                    Promise.all(updates).then(() =>
                                      runWindowtitleRule(firstRow, group),
                                    );
                                  }
                                  filteredRows = [...filteredRows];
                                  updatePercentageBars();
                                } else {
                                  handleMarkRowAsChecked(firstRow);
                                }
                              }}
                            />
                            <span
                              class="safe-title-toggle"
                              class:pending={firstRow.safeStatus === "pending"}
                              class:approved={firstRow.safeStatus ===
                                "approved"}
                            >
                              <Button
                                fixedWidth
                                kind="secondary"
                                size="lg"
                                icon={firstRow.safeStatus
                                  ? DONE_ALL_DARK_ICON
                                  : DONE_ALL_ICON}
                                disabled={(isGrouped &&
                                  !isExactWindowTitleGroup) ||
                                  firstRow.safeStatus === "approved" ||
                                  (!firstRow.safeStatus &&
                                    !isUnchangedRow(firstRow))}
                                iconDescription={isGrouped &&
                                !isExactWindowTitleGroup
                                  ? "Only single titles can be standard titles"
                                  : safeTitleTooltip(firstRow)}
                                on:click={() => {
                                  if (!isGrouped || isExactWindowTitleGroup)
                                    requestToggleSafeTitle(firstRow, group);
                                }}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      {#if isExpandable && (expandedGroups[groupKey] ?? false)}
                        {#each group.slice(1) as row, rowIndex}
                          {@const keyboardGroupRowIndex = rowIndex + 1}
                          <div
                            class="row-wrapper"
                            class:keyboard-row-active={keyboardNavigationActive &&
                              keyboardRowKey ===
                                getKeyboardRowKey(
                                  subtaskIndex,
                                  groupIndex,
                                  keyboardGroupRowIndex,
                                )}
                          >
                            <div class="row" class:checked={row.check}>
                              {#if showApplicationName}
                                <AnonElement
                                  readElement="Application"
                                  anontype={row.clearname}
                                  appIcon={`/api/damprojects/app-icon?application=${encodeURIComponent(row.clearname)}`}
                                  firstElement={true}
                                ></AnonElement>
                              {/if}
                              {#each row.substringsRaw as substring, i}
                                <div
                                  class="keyboard-target"
                                  class:keyboard-target-active={keyboardNavigationActive &&
                                    keyboardRowKey ===
                                      getKeyboardRowKey(
                                        subtaskIndex,
                                        groupIndex,
                                        keyboardGroupRowIndex,
                                      ) &&
                                    keyboardColumnIndex === i}
                                  data-keyboard-target={`${getKeyboardRowKey(subtaskIndex, groupIndex, keyboardGroupRowIndex)}-${i}`}
                                  on:mousedown={() =>
                                    setKeyboardCursor(
                                      getKeyboardRowKey(
                                        subtaskIndex,
                                        groupIndex,
                                        keyboardGroupRowIndex,
                                      ),
                                      i,
                                    )}
                                >
                                  <AnonElement
                                    readElement={substring.value}
                                    bind:anontype={substring.type}
                                    selected={selectedElementKeys.includes(
                                      getSelectedElementKey(row, i),
                                    )}
                                    multiSelected={selectedElements.length > 1}
                                    {selectedElementValues}
                                    onSelection={(event) =>
                                      handleSubstringSelection(
                                        row,
                                        substring,
                                        i,
                                        event,
                                      )}
                                    {anontypeOptionsMap}
                                    removeAnonType={substring.value}
                                    on:typeChanged={(e) =>
                                      handleTypeChanged(
                                        row,
                                        substring,
                                        i,
                                        e.detail.oldValue,
                                      )}
                                    on:removeSelected={removeSelectedAnonymizations}
                                    on:sliced={(e) =>
                                      handleSliced(row, substring, e)}
                                    hideLastChar={substring.value.length === 1
                                      ? false
                                      : i < row.substringsRaw.length - 1}
                                  ></AnonElement>
                                </div>
                                {#if i < row.substringsRaw.length - 1 && substring.value.length > 1 && substring.value.endsWith("_")}
                                  <span class="underscore-separator">_</span>
                                {/if}
                                {#if substring.spaceAfter}
                                  <button
                                    class="join-icon-btn"
                                    title="Click to rejoin these elements"
                                    on:click={() => handleUnjoinSpace(row, i)}
                                  >
                                    <img
                                      src={JOIN_INNER_ALT_ICON}
                                      alt="Join elements"
                                      class="join-icon"
                                    />
                                  </button>
                                {/if}
                              {/each}
                              <span
                                class="row-end-border"
                                class:checked={row.check}
                              ></span>
                              <div class="action-buttons-container">
                                <Button
                                  fixedWidth
                                  kind="secondary"
                                  size="lg"
                                  icon={row.check ? CLOSE_ICON : CHECK_ICON}
                                  iconDescription={row.check
                                    ? "Mark as not checked"
                                    : "Mark as checked"}
                                  on:click={() => {
                                    handleMarkRowAsChecked(row);
                                  }}
                                />
                                <span
                                  class="safe-title-toggle"
                                  class:pending={row.safeStatus === "pending"}
                                  class:approved={row.safeStatus === "approved"}
                                >
                                  <Button
                                    fixedWidth
                                    kind="secondary"
                                    size="lg"
                                    icon={row.safeStatus
                                      ? DONE_ALL_DARK_ICON
                                      : DONE_ALL_ICON}
                                    disabled={row.safeStatus === "approved" ||
                                      (!row.safeStatus && !isUnchangedRow(row))}
                                    iconDescription={safeTitleTooltip(row)}
                                    on:click={() => requestToggleSafeTitle(row)}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        {/each}
                      {/if}
                    </div>
                  </div>
                {/each}
              </div>
            {/each}
            <AnonymizationReviewPagination
              previousText={hasPreviousPage
                ? `Previous ${selectedAmountItems}`
                : "Previous task"}
              nextText={hasNextPage
                ? `Next ${selectedAmountItems}`
                : "Next Task"}
              previousDisabled={!hasPreviousPage}
              nextDisabled={!hasNextPage && !hasNextTask}
              onMarkShown={handleMarkAllAsChecked}
              onPrevious={handleMoveToPreviousPage}
              onNext={hasNextPage ? handleMoveToNextPage : handleMoveToNextTask}
            />
          </section>
        </div>
      {/if}
    </div>
    <AnonymizationShortcutPanel
      showApplicationSetting
      bind:showApplicationName
    />
  </div>
</SectionWrapper>

<PaxbotChat
  bind:open={paxbotOpen}
  heading="Anonymization Assistant"
  subheading="Masks and elements review"
  starterQuestions={paxbotStarterQuestions}
  requestAnswer={requestPaxbotAnswer}
/>

<AnonymizationRuleModal
  bind:open={windowtitleRuleModalOpen}
  loading={windowtitleRuleLoading}
  review={windowtitleRulePreview}
  itemLabel="Window title"
  on:close={() => {
    windowtitleRuleModalOpen = false;
    windowtitleRuleLoading = false;
    windowtitleRulePreview = null;
  }}
  on:apply={applyWindowtitleRule}
/>
<Modal
  bind:open={safeTitleModalOpen}
  actions
  autowidth
  preventCloseOnClickOutside
  modalHeading="Does this title only show the program or a standard function?"
  primaryButtonText="Yes, standard title"
  primaryButtonAction={confirmSafeTitle}
  secondaryButtonAction={cancelSafeTitle}
  on:close={cancelSafeTitle}
>
  <div class="standard-title-guide">
    <p>
      <strong>Yes</strong>, for example File Explorer, Open File, Excel or
      Settings.
    </p>
    <p><strong>No</strong>, if the title contains</p>
    <ul>
      <li>names of people, customers or colleagues</li>
      <li>file, folder or project names</li>
      <li>customer or case numbers, dates or search terms</li>
      <li>internal names of your company, for example team or channel names</li>
    </ul>
    <p>
      After a review, this title is checked automatically in future projects.
    </p>
  </div>
</Modal>
<Modal
  bind:open={openModal}
  actions
  autowidth
  modalClass="anonymization-group-modal"
  preventCloseOnClickOutside
  modalHeading="Apply change to group?"
  secondaryButtonText="Change all entries in group"
  primaryButtonText="Change only selected entry"
  primaryButtonVariant="secondary"
  secondaryButtonAction={handleChangeTypeForGroup}
  primaryButtonAction={handleChangeTypeForOneRow}
  on:close={handleCancelTypeChange}
>
  <p class="modal-group-description">
    This group contains {pendingGroup?.length || 0} similar entries. Apply this change
    to all entries at this position or to the selected entry only.
  </p>
  {#if pendingGroup?.length > 3}
    <p class="modal-preview-heading">Preview of the first 3 replacements:</p>
  {:else}
    <div class="modal-preview-spacer" aria-hidden="true"></div>
  {/if}
  <div class="modal-group-previews">
    {#each pendingPreviewRows as previewRow}
      {@const targetType = getPendingTargetType(previewRow.originalValue)}
      <div class="modal-change-preview">
        <span
          class="value_change"
          class:anonymized_value={isAnonymizedState(
            previewRow.currentType,
            previewRow.originalValue,
          )}
          class:original_value={!isAnonymizedState(
            previewRow.currentType,
            previewRow.originalValue,
          )}
          title={previewRow.currentType}>{previewRow.currentType}</span
        >
        <span class="modal-change-arrow">→</span>
        <span
          class="value_change"
          class:anonymized_value={isAnonymizationType(targetType)}
          class:original_value={!isAnonymizationType(targetType)}
          title={targetType}>{targetType}</span
        >
        {#if previewRow.isSelected}
          <span class="selected-entry-label">(selected entry)</span>
        {/if}
      </div>
    {/each}
  </div>
  <div slot="left-buttons">
    <Button text="Cancel" on:click={handleCancelTypeChange} kind="secondary" />
  </div>
</Modal>

<style>
  .anonymization-section {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
  }

  .content_wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    min-height: 0;
    overflow: hidden;
    padding: 0.81rem 1.19rem 0.81rem 0.88rem;
    height: 100%;
    min-height: calc(100vh - 6rem);
    flex: 1;
    width: auto;
    min-width: 0;
  }

  :global(.anonymization-group-modal .bx--modal-content) {
    width: 100% !important;
    max-width: none !important;
  }

  :global(.anonymization-group-modal .bx--modal-scroll-content),
  :global(.anonymization-group-modal .modal_wrapper) {
    width: 100% !important;
    max-width: none !important;
  }

  :global(.anonymization-group-modal p) {
    width: 100% !important;
    max-width: none !important;
    padding-right: 0 !important;
  }

  .main {
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    /* display: grid;
    grid-template-columns: 0.62fr 0.38fr;
    gap: 0.75rem; */
    display: flex;
    flex-direction: column;
    gap: var(--control-gap);
    overflow: hidden;
    flex: 1;
    min-height: 0;
  }

  .row.checked :global(.read-element-wrapper) {
    display: none;
  }

  .loading_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    justify-content: center;
    padding: 1rem 0;
  }

  .empty-filter-state {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 2rem 0.5rem;
    width: 400px;
  }

  .empty-filter-state p {
    margin: 0;
  }

  .header-status {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--control-gap);
  }

  .rows-container {
    /* display: inline-flex; */
    display: flex;
    flex-direction: column;
    gap: var(--control-gap);
    min-width: 0;
    flex: 1;
    min-height: 0;
    box-sizing: border-box;
    padding-top: var(--control-gap);
    overflow: auto;
  }

  .row-wrapper {
    display: flex;
    flex-direction: row;
    gap: var(--control-gap);
  }

  .keyboard-target {
    position: relative;
    display: flex;
    border-radius: 0.35rem;
  }

  .keyboard-target.keyboard-target-active {
    outline: 2px solid var(--pax-black);
    outline-offset: 2px;
    z-index: 1;
  }

  .keyboard-target.keyboard-target-active::before {
    content: "";
    position: absolute;
    top: -0.55rem;
    left: 50%;
    width: 0;
    height: 0;
    border-left: 0.32rem solid transparent;
    border-right: 0.32rem solid transparent;
    border-top: 0.42rem solid var(--pax-black);
    transform: translateX(-50%);
    pointer-events: none;
  }

  .keyboard-row-active .row {
    box-shadow: 0 0 0 1px rgba(255, 90, 20, 0.18);
  }

  .group-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--control-gap);
  }

  .group-wrapper.has-group {
    display: grid;
    grid-template-columns: 2.5rem minmax(0, 1fr);
    align-items: stretch;
    column-gap: var(--control-gap);
  }

  .group-toggle {
    display: flex;
    align-items: stretch;
  }

  .group-toggle :global(.button_wrapper.long) {
    height: 100%;
    min-height: 4rem;
  }

  .group-rows {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: var(--control-gap);
  }

  .subtask-group {
    display: flex;
    flex-direction: column;
    gap: var(--control-gap);
  }

  .group-count-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    min-width: 2.5rem;
    min-height: 4rem;
    margin-right: -0.45rem;
    border-radius: 0.3125rem;
    background: var(--pax-black);
    color: var(--pax-white);
    font-size: 0.85rem;
    font-weight: 700;
  }

  .row {
    /* display: inline-flex; */
    display: flex;
    padding-left: 0.625rem;
    justify-content: start;
    align-items: center;
    gap: var(--control-gap);
    border-radius: 0.3125rem;
    border-left: 10px solid #ef8484;
    background: var(--pax-smoke);
    width: fit-content;
    min-width: 0;
    /* max-width: 100%; */
    align-self: self-start;
  }

  .checked {
    border-left: 10px solid #8ef095;
  }

  .row-end-border {
    width: 9px;
    min-width: 9px;
    align-self: stretch;
    background: #ef8484;
    border-radius: 0 3px 3px 0;
    margin-left: -0.2rem;
    margin-right: -0.45rem;
  }

  .row-end-border.checked {
    background: #8ef095;
  }

  .safe-title-toggle {
    display: flex;
  }

  .standard-title-guide {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
  }

  .standard-title-guide p {
    margin: 0;
  }

  .standard-title-guide ul {
    margin: 0;
    padding-left: 1.25rem;
    list-style: disc;
  }

  .standard-title-guide li {
    display: list-item;
  }

  .safe-title-toggle.pending :global(.button_wrapper),
  .safe-title-toggle.pending :global(.button_wrapper:hover) {
    background-color: var(--pax-blue-new);
  }

  .safe-title-toggle.approved :global(.button_wrapper),
  .safe-title-toggle.approved :global(.button_wrapper:hover) {
    background-color: var(--pax-green-new);
    opacity: 1;
  }

  .action-buttons-container {
    display: flex;
    gap: 0.25rem;
  }

  .join-icon-btn {
    background: none;
    border: none;
    padding: 0;
    padding-top: 16px;
    cursor: pointer;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    opacity: 0.5;
    transition: opacity 0.2s;
  }

  .join-icon-btn:hover {
    opacity: 1;
  }

  .join-icon {
    width: 1rem;
    height: 1rem;
    transform: rotate(-90deg);
  }

  .underscore-separator {
    display: flex;
    align-items: flex-end;
    padding-top: 16px;
    font-size: 0.75rem;
    color: var(--pax-sub, #474752);
    user-select: none;
  }

  .value_change {
    display: inline-block;
    padding: 0.2rem 0.4rem;
    border-radius: 0.3125rem;
    font-weight: 500;
    line-height: 1.2;
  }

  .value_change.original_value {
    background: #f2f2f2;
    color: var(--pax-black, #1c1c20);
  }

  .value_change.anonymized_value {
    background: #8dcfff;
    color: #1c1c20;
  }

  .modal-change-preview {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    margin-top: 0.75rem;
  }

  .modal-group-description {
    width: 100%;
    max-width: none;
  }

  .modal-preview-heading {
    width: 100%;
    max-width: none;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .modal-preview-spacer {
    height: 1rem;
  }

  .modal-group-previews {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .modal-group-previews .modal-change-preview {
    margin-top: 0;
  }

  .modal-change-preview .value_change {
    min-width: 0;
    width: fit-content;
    max-width: calc(50% - 0.75rem);
    flex: 0 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .modal-change-arrow {
    color: var(--pax-sub, #474752);
    font-size: 1rem;
  }

  .selected-entry-label {
    color: var(--pax-sub, #474752);
    font-size: 0.75rem;
    line-height: 1.2;
    white-space: nowrap;
  }
</style>
